import { render, staticRenderFns } from "./itemDetail.vue?vue&type=template&id=4a22bb7d&scoped=true"
import script from "./itemDetail.vue?vue&type=script&lang=js"
export * from "./itemDetail.vue?vue&type=script&lang=js"
import style0 from "./itemDetail.vue?vue&type=style&index=0&id=4a22bb7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22bb7d",
  null
  
)

export default component.exports